import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
const currentYear = new Date().getFullYear();
const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const ConvertTimeStampToDateString = function (timestamp) {
  let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
  let t = arguments.length > 2 ? arguments[2] : undefined;
  let displayTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  let customFormat = arguments.length > 4 ? arguments[4] : undefined;
  // require(`dayjs/locale/${language}`);
  var date = new Date(timestamp);
  if (customFormat) {
    return dayjs(date).locale(language).format(customFormat);
  }
  // const { t } = useTranslation();
  const dayName = date.toString().split(" ")[0];
  return "".concat(t(dayName), ", ").concat(dayjs(date).locale(language).format(displayTime ? "D MMM YY HH:mm A" : "D MMM YY"));
  // const dayName = date.toString().split(" ")[0];
  // return `${date.toDateString()}`;
};

const generateDateDisplayed = (normalisedDate, t) => {
  // const { t } = useTranslation();
  if (!normalisedDate) return "TBD";
  var refined_date = ConvertDateStringToDate(normalisedDate);
  var month = t ? t(monthNames[refined_date.getMonth()]) : monthNames[refined_date.getMonth()];
  var day = refined_date.getDate();
  var year = refined_date.getFullYear();
  const current_year = new Date().getFullYear();
  return "".concat(day, " ").concat(month, " ").concat(year !== current_year ? year : "");
};
const ConvertValueToDateString = function (value) {
  let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
  let t = arguments.length > 2 ? arguments[2] : undefined;
  // require(`dayjs/locale/${language}`);
  // const { t } = useTranslation();
  const dayName = dayjs(value, "MM-DD-YYYY").toDate().toString().split(" ")[0];
  return "".concat(t(dayName), ", ").concat(dayjs(value, "MM-DD-YYYY").locale(language).format("D MMM YY"));
};
// const ConvertDateToDateString = (date) => {
//   const dayName = date.toString().split(" ")[0];
//   return `${dayName}, ${dayjs(date, "MM-DD-YYYY").format("D MMM YY")}`;
// }
const ConvertDateToDateString = function (date) {
  let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
  let t = arguments.length > 2 ? arguments[2] : undefined;
  // require(`dayjs/locale/${language}`);
  const dayName = date.toString().split(" ")[0];
  const targetFormat = date.getFullYear() !== currentYear ? "D MMM YY" : "D MMM";
  return "".concat(t(dayName), ", ").concat(dayjs(date).locale(language).format(targetFormat));
};
const ConvertToTimeStampFromDateString = string => {
  return new Date(string).getTime() / 1000;
};
const ConvertDateStringToNumerical = string => {
  return dayjs(string, "MM-DD-YYYY").toDate().getTime();
};
const ConvertDateStringToDate = function (string) {
  let dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "MM-DD-YYYY";
  if (string) return dayjs(string, dateFormat).toDate();else return dayjs().toDate();
};
const ConvertDateToDateStringFormat = function (date) {
  let dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "MM-DD-YYYY";
  if (date) return dayjs(date).format(dateFormat);else return dayjs().format(dateFormat);
};
const getDaysInMonth = (month, year) => new Array(31).fill("").map((v, i) => new Date(year, month - 1, i + 1)).filter(v => v.getMonth() === month - 1).map(v => dayjs(v).get("date"));
var dateConverter = {
  ConvertTimeStampToDateString,
  ConvertValueToDateString,
  ConvertDateToDateString,
  ConvertToTimeStampFromDateString,
  ConvertDateStringToNumerical,
  ConvertDateStringToDate,
  generateDateDisplayed,
  ConvertDateToDateStringFormat,
  getDaysInMonth
};

export { dateConverter as d };
